import moment from "moment";

// Flujo real de revalidación, en orden. El estatus es el último paso cumplido (lo calcula el back);
// DETENIDO se marca a mano.
export const PASOS = [
  { campo: "avisoArribo", label: "Aviso de arribo", estatus: "Aviso de arribo" },
  { campo: "cartasEnviadas", label: "Cartas encomienda enviadas", estatus: "Cartas enviadas" },
  { campo: "cartasAplicadas", label: "Cartas aplicadas", estatus: "Cartas aplicadas" },
  { campo: "solicitudPago", label: "Solicitud de pago a naviera", estatus: "Pago solicitado" },
  { campo: "pagoConfirmado", label: "Pago confirmado", estatus: "Pago confirmado" },
  { campo: "revalidacionEnviada", label: "Revalidación enviada al broker", estatus: "Revalidación enviada" },
  { campo: "telexEnviado", label: "Telex / SWB enviado al broker", estatus: "Telex / SWB enviado" },
  { campo: "despachado", label: "Despachado", estatus: "Despachado" },
  { campo: "fechaEIR", label: "EIR recibido", estatus: "EIR recibido" },
];
export const estatusDePasos = (r = {}) => {
  let ultimo = "";
  PASOS.forEach((p) => { if (r[p.campo]) ultimo = p.estatus; });
  return ultimo;
};

export const ESTATUS = [
  ...PASOS.map((p, i) => ({ value: p.estatus, color: i < 3 ? "info" : i < 5 ? "warning" : i < 8 ? "primary" : "success" })),
  { value: "Cerrado", color: "success" },
  { value: "DETENIDO", color: "danger" },
];
export const colorEstatus = (e) => (ESTATUS.find((x) => x.value === e) || {}).color || "secondary";

export const MODALIDADES = ["CY-CY", "RAIL PANTACO"];
export const TAMANOS = ["20'", "40'", "40' HC", "45'"];
export const ESTATUS_COBRO = ["", "PENDIENTE", "FACTURADO", "COBRADO"];
export const ESTATUS_DEMORAS = ["", "SOLICITADO", "PAGADO"];

// Documentos (misma carpeta de Cloudinary y bandera que ListadoContenedores; HBL es nuevo)
export const DOCUMENTOS = [
  { tipo: "hbl", label: "HBL", icon: "fas fa-file-contract", grupo: "Revalidación", destacado: true },
  { tipo: "bl", label: "BL", icon: "fas fa-file-alt", grupo: "Revalidación", destacado: true },
  { tipo: "EIR", label: "EIR", icon: "fas fa-clipboard-check", grupo: "Revalidación", destacado: true },
  { tipo: "BLRevalidado", label: "BL Revalidado", icon: "fas fa-stamp", grupo: "Revalidación" },
  { tipo: "demorasCartas", label: "Demoras y Cartas", icon: "fas fa-envelope-open-text", grupo: "Revalidación" },
  { tipo: "garantia", label: "Garantía", icon: "fas fa-shield-alt", grupo: "Revalidación" },
  { tipo: "telex", label: "Telex / SWB", icon: "fas fa-paper-plane", grupo: "Revalidación" },
  { tipo: "pagoNaviera", label: "Comprobante pago naviera", icon: "fas fa-money-check-alt", grupo: "Revalidación" },
  { tipo: "packing", label: "Packing List", icon: "fas fa-boxes", grupo: "Embarque" },
  { tipo: "invoice", label: "Invoice", icon: "fas fa-file-invoice", grupo: "Embarque" },
  { tipo: "fichaTecnica", label: "Ficha Técnica", icon: "fas fa-clipboard-list", grupo: "Embarque" },
  { tipo: "cargosLocales", label: "Cargos Locales", icon: "fas fa-receipt", grupo: "Embarque" },
  { tipo: "previo", label: "Previo", icon: "fas fa-camera", grupo: "Aduana" },
  { tipo: "DODA", label: "DODA", icon: "fas fa-qrcode", grupo: "Aduana" },
  { tipo: "prealta", label: "Prealta", icon: "fas fa-file-signature", grupo: "Aduana" },
  { tipo: "validacion", label: "Validación", icon: "fas fa-check-double", grupo: "Aduana" },
  { tipo: "boleta", label: "Boleta", icon: "fas fa-ticket-alt", grupo: "Entrega" },
  { tipo: "transporte", label: "Transporte", icon: "fas fa-truck", grupo: "Entrega" },
  { tipo: "cartaPorte", label: "Carta Porte", icon: "fas fa-route", grupo: "Entrega" },
  { tipo: "polizaSeguro", label: "Póliza de Seguro", icon: "fas fa-umbrella", grupo: "Entrega" },
];

export const IVA = 0.16;
const num = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};
export const fmtNum = (v, dec = 0) =>
  new Intl.NumberFormat("en-US", { minimumFractionDigits: dec, maximumFractionDigits: dec }).format(num(v));
export const fmtUSD = (v) => "$" + fmtNum(v, 2);
export const fmtMXN = (v) => "$" + fmtNum(v, 2);

// Mismas reglas que el back (RevalidacionesController.calculaDemoras).
// cerrada = entregado o con EIR: ya no cuenta como demora vencida.
export function calculaDemoras(inicio, diasLibres, fechaEIR, cerrada = false) {
  if (!inicio || diasLibres === null || diasLibres === undefined || diasLibres === "") {
    return { deadline: "", corte: "", diasDemora: 0, diasRestantes: null, cerrada };
  }
  const deadline = moment(inicio, "YYYY-MM-DD").add(Number(diasLibres), "days");
  if (cerrada && !fechaEIR) {
    return { deadline: deadline.format("YYYY-MM-DD"), corte: "", diasDemora: 0, diasRestantes: null, cerrada };
  }
  const hoy = moment().startOf("day");
  const corte = fechaEIR ? moment(fechaEIR, "YYYY-MM-DD") : hoy;
  const diasDemora = Math.max(0, corte.diff(deadline, "days"));
  return {
    deadline: deadline.format("YYYY-MM-DD"),
    corte: diasDemora > 0 ? corte.format("YYYY-MM-DD") : "",
    diasDemora,
    diasRestantes: fechaEIR ? null : deadline.diff(hoy, "days"),
    cerrada,
  };
}

// Semáforo de demoras: vencido / por vencer (≤3 días) / en tiempo / devuelto / cerrado.
// "danger" solo para demoras que siguen corriendo (las que cuentan como vencidas).
export function semaforoDemoras(d, fechaEIR) {
  if (!d || !d.deadline) return { color: "secondary", texto: "Sin días libres" };
  if (fechaEIR) return d.diasDemora > 0 ? { color: "dark", texto: `EIR · ${d.diasDemora} d de demora` } : { color: "success", texto: "Devuelto en tiempo" };
  if (d.cerrada) return { color: "success", texto: "Entregado" };
  if (d.diasDemora > 0) return { color: "danger", texto: `Vencido ${d.diasDemora} d` };
  if (d.diasRestantes <= 3) return { color: "warning", texto: d.diasRestantes === 0 ? "Vence hoy" : `Vence en ${d.diasRestantes} d` };
  return { color: "success", texto: `${d.diasRestantes} d libres` };
}

// Totales de cobro (columnas azules y rojas del Excel)
export function calculaTotales(r = {}) {
  const total = num(r.cargosLocales) + num(r.servicioML);
  const totalIVA = total * (1 + IVA);
  const totalMXN = num(r.tipoCambio) > 0 ? totalIVA * num(r.tipoCambio) : 0;
  const extras = (r.cargosExtra || []).map((x) => {
    const subtotal = num(x.monto) + num(x.servicioML);
    return { ...x, subtotal, totalIVA: subtotal * (1 + IVA) };
  });
  const totalExtras = extras.reduce((s, x) => s + x.totalIVA, 0);
  const extrasPorCobrar = extras.filter((x) => x.cobrado !== "Si").reduce((s, x) => s + x.totalIVA, 0);
  const demorasIVA = num(r.montoDemoras) * (1 + IVA);
  return {
    total,
    totalIVA,
    totalMXN,
    extras,
    totalExtras,
    extrasPorCobrar,
    demorasIVA,
    granTotal: totalIVA + totalExtras + demorasIVA,
  };
}

export const headersAuth = () => ({ Authorization: `Bearer: ${localStorage.getItem("app_token")}` });
